import React from 'react';
import { IconHelpHexagon } from '@tabler/icons-react';

export function Ci2HelpHexIcon({
  label,
  expanded,
  onToggle,
  className = '',
  size = 12,
  stroke = 1.75,
}) {
  const handleKeyDown = (e) => {
    if (!onToggle) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onToggle(e);
    }
  };

  const handleClick = (e) => {
    if (!onToggle) return;
    e.preventDefault();
    e.stopPropagation();
    onToggle(e);
  };

  return (
    <IconHelpHexagon
      size={size}
      stroke={stroke}
      className={['ci2-th-help-icon', className].filter(Boolean).join(' ')}
      role={onToggle ? 'button' : undefined}
      tabIndex={onToggle ? 0 : undefined}
      aria-label={label}
      aria-expanded={expanded}
      onClick={onToggle ? handleClick : undefined}
      onKeyDown={onToggle ? handleKeyDown : undefined}
    />
  );
}
